import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { OverlayPanel, SelectItem } from 'primeng';
import { ITaskInfo, ITaskNote } from '../../interfaces/task-info';
import { IUserOrganisationLevel } from '../../interfaces/user-organisation-level';
import { AccountCodeService, UserService } from '../../services';
import { MapService } from '../../services';
import { OrderTagService } from '../../services';
import { OrganisationsService } from '../../services';
import { TaskService } from '../../services';
import { CustomerServiceFee } from 'src/app/services/customer-service-fee.service';
import { HttpErrorResponse } from '@angular/common/http';
import { OrganisationTypeEnum } from 'src/app/enums/organisation-types';
import { ICustomerServiceFeeFilter } from '../../interfaces/service-fee';
import { TaskType } from '../../enums/task.type';

@Component({
  selector: 'task-control',
  styleUrls: ['./task-control.component.scss'],
  templateUrl: './task-control.component.html',
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class TaskControl implements OnInit {
  private _taskInfo: any;

  @Input() isJobTaggingEnforced: boolean = false;

  @Input('taskInfo')
  public set taskInfo(value: ITaskInfo) {
    this._taskInfo = value;
    if (value) {
      this.isLoaded = true;

      switch (value.taskTypeId) {
        case null:
        case undefined:
          this.taskType = '';
          break;
        case TaskType.DrivenPlated:
        case TaskType.DrivenUninsured:
        case TaskType.DriverInsured:
        case TaskType.DrivenEngineiusGo:
        case TaskType.DrivenPrestige:
        case TaskType.DrivenTurnaround:
          this.taskType = 'Driven';
          break;
        case TaskType.UncoveredTransportedMovement:
        case TaskType.CoveredTransportedMovement:
        case TaskType.PrestigeTransported:
          this.taskType = 'Transported';
          break;
        case TaskType.Inspection:
          this.taskType = 'Inspection';
          break;
        case TaskType.RecoveredSkates:
        case TaskType.RecoveredFullLiftOnly:
        case TaskType.RecoveredMoreEquipmentNeeded:
        case TaskType.RecoveryStandard:
          this.taskType = 'Recovered';
          break;
        case TaskType.DrivenInsuredInspection:
        case TaskType.DrivenPlatedInspection:
          this.taskType = 'Inspect & Collect';
          break;
        default:
          this.taskType = '';
      }
    } else {
      this.taskType = '';
    }
    this.UpdateRouteInfo();
  }

  public get taskInfo(): ITaskInfo {
    return this._taskInfo;
  }

  public taskType: string = '';

  public confirmNotificationTypes: string[] = [];
  public confirmNotificationEntity: string;
  public confirmNotifications: boolean = false;
  public currentStep: number;
  public departmentChosen: any;
  public teamChosen: any;

  public routeInfo: any;

  public isShowVehicleDetails: boolean;

  @Output() isLoadedChange: EventEmitter<any>;
  private _isLoaded: boolean = false;
  public set isLoaded(value: boolean) {
    this._isLoaded = value;
    this.isLoadedChange.emit(value);
  }

  public get isLoaded(): boolean {
    return this._isLoaded;
  }

  @Input('customerDepartmentId')
  public set customerDepartmentId(value: number) {
    this.taskInfo.furtherInformation.customerDepartmentId = value;
  }

  public get customerDepartmentId(): number {
    return this.taskInfo.furtherInformation.customerDepartmentId;
  }

  @Input('customerTeamId')
  public set customerTeamId(value: number) {
    this.taskInfo.furtherInformation.customerTeamId = value;
  }

  public get customerTeamId(): number {
    return this.taskInfo.furtherInformation.customerTeamId;
  }

  public _customerServiceFeeIds: number[];

  public get customerServiceFeeIds(): number[] {
    return this._customerServiceFeeIds;
  }
  @Input('customerServiceFeeIds')
  public set customerServiceFeeIds(value: number[]) {
    this._customerServiceFeeIds = value;
    this.taskInfo.customerServiceFeeIds = value;
    this.taskInfo.customerServiceFees = this._customerServiceFeeIds.map((chargingFeeId) => {
      return { id: chargingFeeId };
    });
  }

  isGuranteeFulfilment: boolean = true;
  accountCodes: SelectItem[];
  orderTags: SelectItem[];
  customerServiceFeeOptions: SelectItem[];

  userOrg: any;
  userOrgLevel: IUserOrganisationLevel;
  departments: SelectItem[];
  teams: SelectItem[];
  isUserImpersonated: boolean;
  public organisationTypeEnum = OrganisationTypeEnum;

  get showMoDelPinContainer(): boolean {
    const organisationSpecificSteps = this.taskInfo.taskOrganisationSpecificSteps;
    const step = organisationSpecificSteps.find((o) => o.ancillaryStepId === 2);
    return step !== undefined;
  }

  constructor(
    private taskService: TaskService,
    private mapService: MapService,
    private accountCodeService: AccountCodeService,
    private orderTagService: OrderTagService,
    private orgService: OrganisationsService,
    private customerServiceFee: CustomerServiceFee,
    private userService: UserService,
  ) {
    this.isLoadedChange = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.currentStep = -1;
    this.isShowVehicleDetails = false;

    if (this.taskInfo != null) {
      this.taskService.GetTaskGuranteeFulfilment(this.taskInfo).then((result: boolean) => {
        this.isGuranteeFulfilment = result;
      });
    }

    this.accountCodeService.getForCurrentUserOrg().then((data) => {
      this.accountCodes = [];
      data.forEach((item) => {
        if (item.isActive) {
          this.accountCodes.push({ label: item.name + ' (' + item.code + ')', value: item.id });
        }
      });

      if (
        this.accountCodes.length > 0 &&
        this.taskInfo.furtherInformation &&
        this.taskInfo.furtherInformation.accountCode == null
      ) {
        this.taskInfo.furtherInformation.accountCode = this.accountCodes[0].value;
      }
    });

    this.orderTagService.getAll().then((data) => {
      this.orderTags = [];
      data.forEach((item) => {
        if (item.isActive) {
          this.orderTags.push({ label: item.description, value: item.id });
        }
      });

      if (this.orderTags) {
        this.orderTags = this.orderTags.sort((a, b) => {
          return a.label.localeCompare(b.label);
        });
      }
    });

    this.orgService.getUserOrganisationLevel().then((level) => {
      this.userOrgLevel = level;

      this.orgService.getOrg(this.userOrgLevel.organisationId).then((org) => {
        this.userOrg = org;
        this.loadDepartments();

        if (this.taskInfo.furtherInformation.customerDepartmentId) {
          this.customerDepartmentId = this.taskInfo.furtherInformation.customerDepartmentId;
        } else if (this.userOrgLevel.defaultDepartmentId) {
          this.customerDepartmentId = this.userOrgLevel.defaultDepartmentId;
        } else if (
          this.userOrgLevel.teamId.length == 1 &&
          this.userOrgLevel.departmentId.length == 1
        ) {
          this.customerDepartmentId = this.userOrgLevel.departmentId[0];
        }

        // Teams
        var promise = this.loadTeams(this.customerDepartmentId);
        if (promise) {
          promise.then((res) => {
            if (this.taskInfo.furtherInformation.customerTeamId) {
              this.customerTeamId = this.taskInfo.furtherInformation.customerTeamId;
            } else if (this.userOrgLevel.defaultTeamId) {
              this.customerTeamId = this.userOrgLevel.defaultTeamId;
            } else if (
              this.userOrgLevel.teamId.length == 1 &&
              this.userOrgLevel.departmentId.length == 1
            ) {
              this.customerTeamId = this.userOrgLevel.teamId[0].id;
            }
          });
        }

        this.loadChargingFees();
      });
    });

    this.isUserImpersonating();
  }

  compareItem(x, y) {
    if (x.name.toLowerCase() > y.name.toLowerCase()) return 1;
    else if (x < y) return -1;
    else return 0;
  }

  loadDepartments() {
    var allDepartments = [];
    if (this.userOrgLevel.teamId.filter((x) => x.isAll).length != 0) {
      allDepartments = this.userOrg.departments;
    } else if (this.userOrgLevel.teamId.filter((x) => x.id).length != 0) {
      allDepartments = this.userOrg.departments.filter(
        (x) => this.userOrgLevel.departmentId.indexOf(x.id) > -1,
      );
    }

    this.departments = [];
    allDepartments.sort(this.compareItem);
    allDepartments.forEach((d) => {
      this.departments.push({ label: d.name, value: d.id });
    });
    //this.departments.sort(this.compareSelectItem);
    this.departments.unshift({ label: 'Select Department...', value: null });
  }

  loadTeams(departmentId: number): Promise<any> {
    var promise = null;
    this.teams = [];

    if (this.customerDepartmentId != null) {
      promise = this.orgService.getDepartment(this.customerDepartmentId).then((data) => {
        this.departmentChosen = data;

        if (data != null) {
          var allTeams = [];
          if (this.userOrgLevel.teamId.filter((x) => x.isAll).length != 0) {
            allTeams = data.teams;
          } else if (this.userOrgLevel.teamId.filter((x) => x.id).length != 0) {
            allTeams = data.teams.filter(
              (x) => this.userOrgLevel.teamId.filter((t) => t.id == x.id).length != 0,
            );
          }

          allTeams.sort(this.compareItem);
          allTeams.forEach((t) => {
            this.teams.push({ label: t.name, value: t.id });
          });

          if (this.taskInfo.furtherInformation.customerTeamId) {
            this.customerTeamId = this.taskInfo.furtherInformation.customerTeamId;
          } else if (
            this.userOrgLevel.teamId.length == 1 &&
            this.userOrgLevel.departmentId.length == 1
          ) {
            this.customerTeamId = this.userOrgLevel.teamId[0].id;
          }
        }
      });
    }
    this.teams.unshift({ label: 'Select Team...', value: null });
    return promise;
  }

  departmentChange(event) {
    this.customerTeamId = null;
    this.loadTeams(event.value).then((result) => {
      this.confirmNotificationEntity = 'Department';
      this.confirmNotificationTypes = [];

      // REINSTATE WHEN NOTIFICATIONS AVAILABLE
      if (false) {
        // @ts-ignore
        if (this.departmentChosen.pickupNotification && this.taskInfo.pickupNotification != true) {
          this.taskInfo.pickupNotification = true;
          this.confirmNotificationTypes.push('Pickup');
        }

        if (
          this.departmentChosen.dropoffNotification &&
          this.taskInfo.dropoffNotification != true
        ) {
          this.taskInfo.dropoffNotification = true;
          this.confirmNotificationTypes.push('Dropoff');
        }

        if (this.confirmNotificationTypes.length > 0) {
          this.confirmNotifications = true;
        }
      }
      if (event.value) {
        this.loadChargingFees();
      }
    });
  }

  teamChange(event) {
    this.confirmNotificationEntity = 'Team';
    this.confirmNotificationTypes = [];

    if (event.value) {
      // Does this Team have pickup/dropoff notifications set ?
      this.orgService.getTeam(event.value).then((response) => {
        this.teamChosen = response;

        // REINSTATE WHEN NOTIFICATIONS AVAILABLE

        if (false) {
          // @ts-ignore
          if (
            this.teamChosen.pickupNotification == true &&
            this.taskInfo.pickupNotification != true
          ) {
            this.confirmNotificationTypes.push('Pickup');
          }
          if (
            this.teamChosen.dropoffNotification == true &&
            this.taskInfo.dropoffNotification != true
          ) {
            this.confirmNotificationTypes.push('Dropoff');
          }

          if (this.confirmNotificationTypes.length > 0) {
            this.confirmNotifications = true;
          }
        }
      });
      this.loadChargingFees();
    }
  }

  EnableNotifications(entity: string, notificationTypes: string[]) {
    this.confirmNotifications = false;

    if (notificationTypes.indexOf('Pickup') > 0) {
      this.taskInfo.pickupNotification = true;
    }
    if (notificationTypes.indexOf('Dropoff') > 0) {
      this.taskInfo.pickupNotification = true;
    }
  }

  UpdateRouteInfo() {
    this.routeInfo = null;
    if (!this.taskInfo || !this.taskInfo.pickupLocation || !this.taskInfo.dropoffLocation) {
      return;
    }

    var origin = [];

    if (this.taskInfo.pickupLocation.latitude) {
      origin.push(this.taskInfo.pickupLocation.latitude);
    }

    if (this.taskInfo.pickupLocation.longitude) {
      origin.push(this.taskInfo.pickupLocation.longitude);
    }

    var destination = [];

    if (this.taskInfo.dropoffLocation.latitude) {
      destination.push(this.taskInfo.dropoffLocation.latitude);
    }

    if (this.taskInfo.dropoffLocation.longitude) {
      destination.push(this.taskInfo.dropoffLocation.longitude);
    }

    const dto = this.mapService.GetRouteDTO(
      this.taskInfo.pickupLocation,
      this.taskInfo.dropoffLocation,
      this.taskInfo.pickupEarliestDateTime,
    );
    this.mapService.GetRoute(dto).then((route) => {
      if (route != null) {
        this.routeInfo = {
          distanceMiles: this.mapService.getMiles(route.distance),
          time: this.mapService.getDateTime(route.duration),
        };
      }
    });
  }

  showVehicleDetails() {
    this.isShowVehicleDetails = true;
  }

  getNotes(notes: ITaskNote[], isPickup: boolean) {
    if (!notes) return [];

    var result = [];
    notes.forEach((x) => {
      if (x.isPickUp == isPickup) {
        result.push(x);
      }
    });

    result.sort((x) => new Date(x.created).getTime());
    return result;
  }

  chargingFeeChange(event) {
    //event.value
    console.log('Selection Change', event.value);
    console.log('New list of selections', this.customerServiceFeeIds);
  }

  loadChargingFees() {
    this.customerServiceFeeIds = [];
    let filter = <ICustomerServiceFeeFilter>{
      filters: {
        customerId: { value: this.userOrgLevel.organisationId, matchMode: 'equals' },
        departmentId: { value: this.customerDepartmentId, matchMode: 'equals' },
        teamId: { value: this.customerTeamId, matchMode: 'equals' },
      },
    };
    this.customerServiceFee
      .getAll(filter)
      .then((res) => {
        let mandatoryIds: number[] = [];
        this.customerServiceFeeOptions = res.items.map((serviceFeeType) => {
          if (serviceFeeType.isMandatory) {
            mandatoryIds.push(serviceFeeType.id);
            return { label: serviceFeeType.name, value: serviceFeeType.id, disabled: true };
          } else {
            return { label: serviceFeeType.name, value: serviceFeeType.id };
          }
        });
        if (mandatoryIds.length > 0) {
          this.customerServiceFeeIds = mandatoryIds;
        }
      })
      .catch((err) => {
        console.log('Error returned: ', err);
      });
  }

  isUserImpersonating() {
    this.userService
      .isUserImpersonating()
      .then((res) => {
        var resultData: any;
        resultData = res;
        if (resultData != null) {
          this.isUserImpersonated = resultData.isImpersonating;
        } else {
          this.isUserImpersonated = false;
        }
      })
      .catch((errorResponse: HttpErrorResponse) => {
        console.log(errorResponse.message);
      });
  }
}
